import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=5fbfe1cc"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"
import style0 from "./Transactions.vue?vue&type=style&index=0&id=5fbfe1cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports